module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('strong', [_vm._v("YOU ON THE INTERNET PRICING")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LYRIC FROM SONG")]), _vm._v(": "), _c('strong', [_vm._v("“HE TRIED TO PLAY ME”")]), _vm._v(" ON ALBUM: "), _c('strong', [_vm._v("KILLA SEASON")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BY ARTIST")]), _vm._v(": "), _c('strong', [_vm._v("CAM’RON")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It is funny that you are using a vast network of computers in order to find the most affordable items as you research bargains and compare the costs associated with shopping at various stores, while other people simply purchase whatever they want immediately upon seeing it and without regard for cost.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e857c3b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01ch04.vue
// module id = 90
// module chunks = 0